import { Injectable } from '@angular/core';
import { Editor } from 'ngx-editor';
import { Plugin } from 'prosemirror-state';
import { Slice, Fragment } from 'prosemirror-model';
@Injectable({
  providedIn: 'root'
})
export class EditorHelperService {
  constructor() { }
  // Create and return the custom paste plugin
  createCustomPastePlugin(): Plugin {
    return new Plugin({
      props: {
        handlePaste: (view, event, slice) => {
          // Get the text content
          const text = event.clipboardData.getData('text/plain');

          // If the content contains patterns we want to prevent auto-linking
          if (text.match(/\d+\.\d+\.\d+\.\d+/) || text.match(/\d+\.\d+\.\d+/) || text.match(/[\w-]+\.[\w-]+/)) {
            // Insert as plain text instead
            const tr = view.state.tr;
            const textNode = view.state.schema.text(text);
            const plainTextSlice = new Slice(Fragment.from(textNode), 0, 0);
            tr.replaceSelection(plainTextSlice);
            view.dispatch(tr);
            return true; // Prevent default paste handling
          }

          // Use default handling for other content
          return false;
        }
      }
    });
  }
  // HTML enforcement method
  enforceHtmlLinks(htmlString: string): string {
    // Create a temporary DOM element to parse the HTML string
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;

    // Select all the anchor elements within the temporary element
    const links = tempElement.querySelectorAll('a');
    links.forEach(link => {
      const href = link.getAttribute('href');

      // Check if the href exists and doesn't start with "https://" or "http://"
      if (href && !href.startsWith('https://') && !href.startsWith('http://')) {
        link.setAttribute('href', 'https://' + href);
      }
    });

    // Return the modified HTML string from the temporary element
    return tempElement.innerHTML;
  }
  // Create an editor instance with our custom plugin
  createEditor(): Editor {
    return new Editor({
      plugins: [this.createCustomPastePlugin()],
    });
  }
}
